import React from 'react'
import { interpolate } from '../utils/proposalVariables'

const IntroLetter = ({ data, variables }) => {
  return (
    <div className="proposal-section">
      {data?.greeting && (
        <div className="proposal-intro__greeting">{data.greeting}</div>
      )}
      {data?.body && (
        <div className="proposal-section__body">{interpolate(data.body, variables)}</div>
      )}
      <div className="proposal-intro__closing">
        {data?.closing && <div>{data.closing}</div>}
        {data?.signatureName && (
          <div className="proposal-intro__signature-name">{data.signatureName}</div>
        )}
        {data?.signatureTitle && (
          <div className="proposal-intro__signature-title">{data.signatureTitle}</div>
        )}
      </div>
    </div>
  )
}

export default IntroLetter
